import React, { Component } from 'react';
import { connect } from 'react-redux';
import BitcoinTradesView from './BitcoinTrades.view';

export class BitcoinTradesContainer extends Component {

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_BITCOIN_TRADES_DATA'
    });
  }

  render() {
    return (<BitcoinTradesView
      {...this.state}
      {...this.props}
    />);
  }

}

function mapStateToProps(state) {
  const { bitcoinTrades } = state;
  return {
    ...bitcoinTrades,
  };
}

export default connect(mapStateToProps)(BitcoinTradesContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/BitcoinTrades/BitcoinTrades.container.js